<template>
  <b-col id="vlCardBigContainer">
    <b-row>
      <div class="vlCardBigtitle">
        {{ title }}
      </div>
      <slot />
    </b-row>
    <b-row class="mt-3">
      <div v-b-modal="'my-modal' + this.uid" style="text-align: end;" class="vlCardMore">En savoir plus <img src="./moreicon.png" alt="" /></div>

      <b-modal modal-class="cmModalContainer" size="xl" :id="'my-modal' + this.uid" centered hide-footer :title="modalTitle">
        <b-row>
          <div style="color:white"></div>
          <b-col cols="5">
            <ChartSector :sectors="content" class="mt-4" />
          </b-col>
          <b-col cols="12">
            <div class="cmModalTitle">{{ title }}</div>
            <div class="cmModalCard mt-3">
              <b-row style="padding:10px; font-weight:bold">
                <b-col>{{title2}}</b-col>
                <b-col>Répartition</b-col>
              </b-row>
              <b-row v-for="(item, index) in content" :key="index" class="cmModalCardContentRow">
                <b-col>{{ item.name }}</b-col>
                <b-col>{{ Math.round(item.value) }} %</b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </b-modal>
    </b-row>
  </b-col>
</template>
<script>
import ChartSector from "./ChartSector.vue";
export default {
  components: { ChartSector },
  props: ["title","title2", "content", "modalTitle"],
  data() {
    return {
      colors_list: ["#9561E2", "#A574EC", "#B88EF6", "#E1CDFF", "#ECE0FF", "#F5F5F5"],
    };
  },
};
</script>
<style lang="scss">
@import "../../../../../sass/_variables.scss";
.cmModalContainer {
  .cmModalTitle {
    text-align: center;
    font: normal normal bold $mf_ft_size_title Segoe UI;
    letter-spacing: 0px;
    color: $purple_color;
    opacity: 1;
    width: 100%;
  }
  .cmModalCard {
    background: #242527 0% 0% no-repeat padding-box;
    opacity: 1;
    border-radius: 20px;
    color: $mf_ft_color_white;
    .cmModalCardContentRow {
      border-top: 2px solid #121212;
      padding: 10px;
    }
  }
  button {
    color: $purple_color;
    background: transparent;
    border: none;
    font-weight: bold;
    &:focus {
      border: none;
      background: transparent;
    }
    &:active {
      border: none;
      background: transparent;
    }
  }
  .modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1040;
    width: 100vw;
    height: 100vh;
  }

  .modal-content {
    background-color: #121212 !important;
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 20px;
    opacity: 1;
    .modal-header {
      border-bottom: none !important;
      text-align: center;
      font: normal normal normal $mf_ft_size_title Dosis;
      letter-spacing: 0px;
      color: #ffffff;
      opacity: 1;
    }
    .modal-body {
      text-align: justify;
    }
  }

  .modalContentCustom {
    text-align: justify;
  }
}
#vlCardBigContainer {
  background: #333436 0% 0% no-repeat padding-box;
  border-radius: 20px;
  opacity: 1;
  margin-top: 10px;
  padding: 20px;

  .vlCardBigtitle {
    text-align: center;
    font: normal normal bold $mf_ft_size_title Segoe UI;
    letter-spacing: 0px;
    color: $purple_color;
    width: 100%;
    opacity: 1;
  }
  .vlCardMore {
    text-align: right;
    font: italic normal normal $mf_ft_size_text Segoe UI;
    letter-spacing: 0px;
    color: $mf_ft_color_white;
    opacity: 1;
    width: 100%;
    &:hover {
      color: $purple_color;
    }
    img {
      width: 40px;
    }
  }
}
</style>
